import { MatMenuTrigger } from '@angular/material/menu';
import {
  AfterViewInit,
  Component,
  DestroyRef,
  OnDestroy,
  inject,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  template: '',
  standalone: false,
})
export abstract class BaseMenuComponent implements AfterViewInit, OnDestroy {
  trigger: MatMenuTrigger;
  protected _menuExpanded = false;
  private _subscriptions: Subscription[] = [];
  private destroyRef = inject(DestroyRef);

  protected constructor() {}

  ngAfterViewInit() {
    this._subscriptions.push(
      this.trigger.menuOpened
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this._menuExpanded = true;
        }),
    );

    this._subscriptions.push(
      this.trigger.menuClosed
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this._menuExpanded = false;
        }),
    );
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
